import { Box, Typography, Grid2 as Grid, useMediaQuery, Chip } from "@mui/material";
import { useMemo } from "react";

import { useTypedSelector } from "@store/store";

import { CabinPricingOptions } from "../molecules/CabinPricingOptions";
import { CruiseDurationAndDestination } from "../molecules/CruiseDurationAndDestination";
import { CruiseTags } from "../molecules/CruiseTags";

export function CruiseOverview() {
  const { cruise } = useTypedSelector((state) => state.search);

  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  const mktTag = useMemo(() => {
    const mktTags = cruise?.cruise?.tags?.find((tag) => tag.type === "MKT");

    return mktTags;
  }, [cruise?.cruise?.tags]);

  return (
    <Box
      sx={{
        py: 4,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Grid spacing={4} container>
        {cruise?.cruise.map && (
          <Grid size={{ xs: 12, md: 7 }}>
            <Box
              component="img"
              src={cruise?.cruise.map}
              alt="ship"
              sx={(theme) => ({
                width: "100%",
                objectFit: "contain",
                overflow: "hidden",
                objectPosition: "center",
                borderRadius: theme.toPx(theme.customShape.smallRadius),
              })}
            />
          </Grid>
        )}

        <Grid size={{ xs: 12, md: 5 }}>
          {mktTag && <Chip label={mktTag.name} color="error" sx={{ mb: 2 }} />}

          <Typography component="h1" variant="heroTitle" color="text-dark">
            {cruise?.cruise.name}
          </Typography>

          <CruiseTags />

          {isDesktop && <CruiseDurationAndDestination />}
        </Grid>
      </Grid>

      {!isDesktop && <CruiseDurationAndDestination />}

      <CabinPricingOptions />
    </Box>
  );
}
